import { colors } from '../foundation';

type Props = {
  color?: typeof colors.primary.red | typeof colors.primary.white | (typeof colors.black)[100];
};

const WifiGood = ({ color = colors.primary.white }: Props) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Network &#38; Coverage/wifi-good">
        <path
          id="Vector"
          d="M2.51172 10.0065C3.75886 8.75817 5.23979 7.7679 6.86986 7.09225C8.49993 6.41661 10.2472 6.06885 12.0117 6.06885C13.7763 6.06885 15.5235 6.41661 17.1536 7.09225C18.7836 7.7679 20.2646 8.75817 21.5117 10.0065M5.26294 13.0065C6.15394 12.1145 7.21201 11.4069 8.37666 10.9241C9.5413 10.4413 10.7897 10.1928 12.0504 10.1928C13.3112 10.1928 14.5596 10.4413 15.7242 10.9241C16.8889 11.4069 17.9469 12.1145 18.8379 13.0065M8.08673 15.989C8.60469 15.4707 9.21969 15.0596 9.89659 14.7791C10.5735 14.4986 11.299 14.3542 12.0317 14.3542C12.7644 14.3542 13.49 14.4986 14.1669 14.7791C14.8438 15.0596 15.4588 15.4707 15.9767 15.989M12.5117 19.5377C12.5117 19.8139 12.2879 20.0377 12.0117 20.0377C11.7356 20.0377 11.5117 19.8139 11.5117 19.5377C11.5117 19.2616 11.7356 19.0377 12.0117 19.0377C12.2879 19.0377 12.5117 19.2616 12.5117 19.5377ZM12.3242 19.5377C12.3242 19.7103 12.1843 19.8502 12.0117 19.8502C11.8391 19.8502 11.6992 19.7103 11.6992 19.5377C11.6992 19.3651 11.8391 19.2252 12.0117 19.2252C12.1843 19.2252 12.3242 19.3651 12.3242 19.5377ZM12.1367 19.5377C12.1367 19.6068 12.0808 19.6627 12.0117 19.6627C11.9427 19.6627 11.8867 19.6068 11.8867 19.5377C11.8867 19.4687 11.9427 19.4127 12.0117 19.4127C12.0808 19.4127 12.1367 19.4687 12.1367 19.5377Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default WifiGood;
